module.exports = __webpack_public_path__ + "img/2025-02-13c_1.d2a5f3f8.jpg";